import { TRANSFER_BALANCE_REDUCER_KEY } from './transferBalanceReducer';

export const getResourceStore = (state) => state[TRANSFER_BALANCE_REDUCER_KEY];
export const getLoadPending = (state) => getResourceStore(state).loadPending;
export const getIsLoading = (state) => getResourceStore(state).isLoading;
export const getLastSyncDate = (state) => getResourceStore(state).lastSyncDate;
export const getError = (state) => getResourceStore(state).error;
export const getResourcesById = (state) => getResourceStore(state).resourcesById;
